import { ApolloClient, InMemoryCache } from "@apollo/client";
import { siteUrl } from "lib/constants";

const client = new ApolloClient({
  uri: `${siteUrl}/graphql`,
  cache: new InMemoryCache(),
});

export default client;
